/**
 * Audit "module" taxonomy — mirrors backend/src/utils/auditModule.ts. A module
 * is derived from the request path so the audit log can be filtered/labelled by
 * the business area a request affected. Keys must stay in sync with the backend.
 *
 * Order matters: deriveModule returns the first module whose pattern the path
 * contains, so more specific patterns come first.
 */
const AUDIT_MODULE_PATTERNS: Array<{ key: string; patterns: string[] }> = [
  { key: 'masterdata', patterns: ['/master-data/master-data'] },
  { key: 'customer', patterns: ['/customer-intake', '/user'] },
  { key: 'registration', patterns: ['/registration'] },
  { key: 'class', patterns: ['/class'] },
  { key: 'coach', patterns: ['/coach'] },
  { key: 'trial', patterns: ['/trial'] },
  { key: 'course', patterns: ['/course'] },
  { key: 'service', patterns: ['/service'] },
  { key: 'attendance', patterns: ['/attendance'] },
  { key: 'report', patterns: ['/report'] },
  { key: 'auth', patterns: ['/auth'] },
];

/** Module keys in display order, for the filter dropdown. */
export const AUDIT_MODULES = [
  'customer',
  'registration',
  'class',
  'coach',
  'trial',
  'course',
  'service',
  'attendance',
  'report',
  'auth',
  'masterdata',
];

/** Returns the module key for a request path, or '' when none matches. */
export const deriveModule = (path: string | null | undefined): string => {
  if (!path) return '';
  const lower = path.toLowerCase();
  const match = AUDIT_MODULE_PATTERNS.find(({ patterns }) =>
    patterns.some((pattern) => lower.includes(pattern)),
  );
  return match ? match.key : '';
};
